import React from 'react'
import "./contact.css"
import {AiTwotoneMail} from "react-icons/ai"
import {BsLinkedin} from "react-icons/bs"
import {AiFillTwitterSquare} from "react-icons/ai"
import { useRef } from 'react';
import emailjs from "emailjs-com"

const Contact = () => {
  const form = useRef();
  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_a276aa6', 'template_lt768og', form.current, 'lXF3-DpImD0bRiU7E')
    
    e.target.reset()
  };


  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact_container">
        <div className="contact_options">
        <article className="contact_option">
          <AiTwotoneMail className='contact_icon'/>
          <h4>Email</h4>
          <h5>cadensmith1123@gmail.com</h5>
          <a href="mailto:cadensmith1123@gmail.com" target="_blank">Send a message</a>
        </article>
        <article className="contact_option">
          <BsLinkedin className='contact_icon'/>
          <h4>LinkedIn</h4>
          <h5>Caden Smith</h5>
          <a href="https://www.linkedin.com/in/caden-smith-7806a3223/" target="_blank">Send a message</a>
        </article>
        <article className="contact_option">
          <AiFillTwitterSquare className='contact_icon' />
          <h4>Twitter</h4>
          <h5>BoreincMedia</h5>
          <a href="https://twitter.com/BoreincMedia" target="_blank">Send a DM</a>
        </article>
        </div>
        {/* End of Contact Options */}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact